import { useEffect } from "react";
import { useRoomContext } from "@livekit/components-react";
import { useLiveKitSession } from "./LiveKitSessionContext";
import { setClientLogContext } from "./clientLogReporter";

/**
 * Inside LiveKitRoom + LiveKitSessionProvider: keeps telemetry JWT + room identity
 * in sync for POST /client/logs (bridge installs once from index.js).
 */
export default function ClientLogSessionSetup() {
  const room = useRoomContext();
  const { telemetryJwt } = useLiveKitSession();

  useEffect(() => {
    setClientLogContext({
      getTelemetryJwt: () => telemetryJwt,
      getRoomContext: () => ({
        roomName: room?.name || "",
        reporterIdentity: room?.localParticipant?.identity || "",
      }),
    });
  }, [room?.name, room?.localParticipant?.identity, telemetryJwt]);

  return null;
}
